import { IBaseApiResponse } from '@/typescript/interfaces/common.interface';
import {
  IBatchListResponse,
  IProductGroupRespone,
  ISubmitLotPayload,
} from '@/typescript/interfaces/inventory.interface';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TokenService } from '@services/auth/token.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  public tabChange$: BehaviorSubject<any> = new BehaviorSubject(false);
  tabChangeAction$ = this.tabChange$.asObservable();

  constructor(private _token: TokenService, public http: HttpClient) {}

  public getNextPageNum: any;
  public searchElement = [
    'Make',
    'Model',
    'Model Year',
    'Body Type',
    'Trim/Type',
    'Exterior Colour',
    'VIN Number',
    'Plate Number',
  ];

  // Inventory api section Start

  addvehicle(vehicle_info: Object) {
    const URL = `${environment.api}inventory/product/add`;

    return this.http
      .post(URL, vehicle_info, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getAllAuctionVehicle(
    type: 1 | 2 | 3 = 1,
    buy: 0 | 1 | 2 = 0,
    page: number = 1
  ) {
    const URL = `${environment.api}inventory/vam/product/list`;
    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: { type, buy, page },
      })
      .pipe(map((result) => result));
  }

  getAllProductListForPagination(pageNum: number = 1) {
    const URL = `${environment.api}inventory/product/list`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: {
          page: pageNum,
          limit: 2,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  removeVehicleList(product_id: any) {
    const URL = `${environment.api}inventory/product/delete/${product_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getvehicleInfo(vehicle_id) {
    const URL = `${environment.v5}inventory/product/view/${vehicle_id}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getBatchView(batch_id: any) {
    const URL = `${environment.api}inventory/batch/view/${batch_id}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  removeBatch(batch_id: any) {
    const URL = `${environment.api}inventory/batch/delete/${batch_id}`;

    return this.http
      .delete(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  // Here
  filterProduct(filter_info: Object): Observable<any> {
    const URL = `${environment.api}inventory/product/search`;

    return this.http
      .post(URL, filter_info, {
        headers: this._token.getTokenHeader(),
        params: {
          type: 1,
          buy: 0,
        },
      })
      .pipe(map((result: any) => result));
  }

  searchProduct(filter_info: Object) {
    const URL = `${environment.api}inventory/product/searchList`;
    return this.http
      .post<IProductGroupRespone>(URL, filter_info, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(debounceTime(3000), distinctUntilChanged(), tap());
  }

  deleteProductImage(image_info: Object) {
    const URL = `${environment.api}image/delete `;

    return this.http.post(URL, image_info, {
      headers: this._token.getTokenHeader(),
    });
  }

  // END

  // Batches Section

  createBatch(batch_info: Object) {
    const URL = `${environment.api}inventory/batch/create`;

    return this.http.post(URL, batch_info, {
      headers: this._token.getTokenHeader(),
    });
  }

  fetchBatches(page: number = 1, limit: number = 10) {
    const URL = `${environment.api}inventory/batch/list`;

    return this.http.get(URL, {
      headers: this._token.getTokenHeader(),
      params: { page, limit },
    });
  }

  getAllBatchSearchData(batch_data: any) {
    const URL = `${environment.api}inventory/batch/search/${batch_data}`;

    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  inventoryListPagination(nextPage: number = 1) {
    const URL = `${environment.api}inventory/product/list`;
    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: {
          page: nextPage,
          limit: 10,
        },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  inventoryRetailList(nextPage: number, type: 1 | 2 | 3, buy: 0 | 1 | 2 = 0) {
    // buy: 0 | 1 | 2 = 0
    // const URL = `${environment.api}inventory/vam/product/list`;
    const URL = `${environment.v5}vam/product/list`;
    const newParams = {
      page: nextPage,
      limit: 10,
      type: type,
    };
    buy === 2 ? (newParams['sold'] = true) : (newParams['buy'] = buy);
    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: newParams,
        // {
        //   page: nextPage,
        //   limit: 10,
        //   type: type,
        //   buy: buy,
        // },
      })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  getSoldVehicles(pageNo: number, type: 1 | 2 | 3 = 1, buy: 0 | 1 | 2 = 2) {
    // const URL = `${environment.api}inventory/vam/product/list`;
    // return this.http.get(URL, { headers: this._token.getTokenHeader(), params: { type, buy, limit: 10 } }).pipe(map(result => result));
    const URL = `${environment.newInventoryApi}auction/sold`;
    return this.http
      .get(URL, {
        headers: this._token.getTokenHeader(),
        params: { page: pageNo, limit: 10 },
      })
      .pipe(map((result) => result));
  }

  vehicleActiveStatusUpdate(productId: string, payload: object) {
    const URL = `${environment.payment_api}product/status/${productId}`;

    return this.http
      .post(URL, payload, { headers: this._token.getTokenHeader() })
      .pipe(map((result) => result));
  }

  purchaseView(paymentId: string) {
    const URL = `${environment.v5}payment/view/${paymentId}`;

    return this.http.get(URL).pipe(map((result) => result));
  }

  uploadPurchaseInvoice(productId: string, payload: object) {
    const URL = `${environment.recycleApi}inventory/invoice/create/${productId}`;

    return this.http.post(URL, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  getPurchaseInvoice(productId: string) {
    const URL = `${environment.v5}inventory/invoice/view/${productId}`;

    return this.http.get(URL);
  }

  deleteAfterSellDocs(productId: string, payload: object) {
    const URL = `${environment.recycleApi}inventory/invoice/delete/${productId}`;

    return this.http.post(URL, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  userDocApproveReject(paymentId: string, payload: object) {
    const URL = `${environment.recycleApi}inventory/payment/doc/${paymentId}`;

    return this.http.post(URL, payload);
  }

  vehicleReserveStatus(productId: string, payload: object) {
    const URL = `${environment.recycleApi}inventory/payment/order/status/${productId}`;

    return this.http.post(URL, payload);
  }

  getSelectedProduct(payload: object, type: 1 | 2 | 3, buy: 0 | 1 | 2 = 0) {
    const URL = `${environment.api}inventory/product/search`;
    const newParams = {
      type: type,
    };
    buy === 2 ? (newParams['sold'] = true) : (newParams['buy'] = buy);

    return this.http.post(URL, payload, { params: newParams });
  }

  tabChangeEvent(value: boolean) {
    this.tabChange$.next(value);
  }

  getFilterOptions(payload: object, type: number, buy: number) {
    return this.http.post(
      `${environment.v5}inventory/product/filters`,
      { ...payload, search_element: this.searchElement },
      { params: { type: type, buy: buy } }
    );
  }

  getParticularFilterOptions(payload: object, type: number, buy: number) {
    return this.http.post(
      `${environment.v5}inventory/particular/product/filter`,
      { ...payload, search_element: this.searchElement },
      { params: { type: type, buy: buy } }
    );
  }

  createInstantIndividualAuction(payload: object) {
    const url = `${environment.pdiAPI}individual/auction`;

    return this.http.post(url, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  createTimedIndividualAuction(payload: object) {
    const url = `${environment.v4}auctions/add`;

    return this.http.post(url, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  getBatchList(
    params?:
      | HttpParams
      | {
          [param: string]:
            | string
            | number
            | boolean
            | readonly (string | number | boolean)[];
        }
  ) {
    const url = `${environment.v4}batch/list`;
    // const url2 = `http://192.168.0.157:3000/stage/batch/list`;
    return this.http
      .get<IBatchListResponse>(url, {
        params,
      })
      .pipe(
        map((respone) => {
          const resultsArr = respone?.data?.map((_result) => ({
            id: _result?.product_group_id,
            name: _result?.group_name,
            total_rows: +_result?.total_rows,
          }));
          return resultsArr;
        })
      );
  }

  fetchProducts(
    productGroupId: string,
    params?:
      | HttpParams
      | {
          [param: string]:
            | string
            | number
            | boolean
            | readonly (string | number | boolean)[];
        }
  ) {
    const url = `${environment.v4}search/productGroup/${productGroupId}`;
    // const url2 = `http://192.168.0.157:3000/stage/search/productGroup/${productGroupId}`;
    return this.http.get<IProductGroupRespone>(url, {
      params,
    });
  }

  submitLot(payload: ISubmitLotPayload) {
    const url = `${environment.v4}update/lot`;
    // const urlLocal = `http://192.168.0.157:3000/stage/update/lot`;

    return this.http.post<IBaseApiResponse>(url, payload, {
      headers: this._token.getTokenHeader(),
    });
  }

  productSold(productId: string) {
    const url = `${environment.v5}product/sold/${productId}`;

    return this.http.get<IBaseApiResponse>(url, {
      headers: this._token.getTokenHeader(),
    });
  }
}
